import DataFooterButtons from '@/features/DataHub/components/ExportDrawer/DataFooterButtons';
import ImageFooterButtons from '@/features/DataHub/components/ExportDrawer/ImageFooterButtons';
import { useExportSettings } from '@/features/DataHub/modules/Export/context/exportContexts';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';

const FooterButtons = () => {
  const { exportSettings } = useExportSettings();

  if (exportSettings.exportType === ExportTypes.DATA) {
    return <DataFooterButtons />;
  }

  if (exportSettings.exportType === ExportTypes.IMAGE && exportSettings.exportSubType) {
    return <ImageFooterButtons />;
  }

  return null;
};

export default FooterButtons;
